module.exports = __webpack_public_path__ + "img/청담 술집.f473a77f.png";